module.exports = __webpack_public_path__ + "r-v3/img/menu_translation_off.c2a575f8.png";